module.exports = __webpack_public_path__ + "static/media/logo1.020e0f52.png";